module.exports = __webpack_public_path__ + "media/images/webpage/shared/about/plan-84cd2e25a509f69257ee86542b3aa94c.webp";